
// src/components/DashboardPresenze.js
import React, { useEffect, useState } from 'react';
import { api } from '../utils/api';

const DashboardPresenze = () => {
  const [presenze, setPresenze] = useState([]);

  useEffect(() => {
    const fetchPresenze = async () => {
      try {
        const res = await api.get('/presenze');
        setPresenze(res.data);
      } catch (err) {
        console.error('Errore nel recupero presenze:', err);
      }
    };

    fetchPresenze();
  }, []);

  const formatOra = (val) => {
    if (!val) return '-';
    const date = new Date(val);
    return isNaN(date.getTime()) || date.getFullYear() < 1970
      ? '-'
      : date.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  };

  const formatData = (val) => {
    if (!val) return '-';
    const date = new Date(val);
    return isNaN(date.getTime()) ? '-' : date.toLocaleDateString('it-IT');
  };

  const minutiToHHMM = (minuti) => {
    const ore = Math.floor(minuti / 60);
    const min = minuti % 60;
    return `${ore}h ${min.toString().padStart(2, '0')}m`;
  };

  const missingStyle = { color: 'red', fontWeight: 'bold' };

  return (
    <div>
      <h3>📅 Le tue presenze</h3>
      <table border="1" cellPadding="6" style={{ marginTop: '20px' }}>
        <thead>
          <tr>
            <th style={{ minWidth: '110px' }}>Data</th>
            <th style={{ minWidth: '120px' }}>Entrata Mattina</th>
            <th style={{ minWidth: '120px' }}>Uscita Mattina</th>
            <th style={{ minWidth: '140px' }}>Entrata Pomeriggio</th>
            <th style={{ minWidth: '140px' }}>Uscita Pomeriggio</th>
            <th style={{ minWidth: '120px' }}>Ore</th>
          </tr>
        </thead>
        <tbody>
          {presenze.map((p, index) => {
            const minutiCalcolati = p.ore_calcolate_minuti ?? 0;

            return (
              <tr key={index}>
                <td>{formatData(p.data_presenza)}</td>
                <td style={p.mattina_missing_uscita ? missingStyle : undefined}>{formatOra(p.entrata_matt)}</td>
                <td>{formatOra(p.uscita_matt)}</td>
                <td style={p.pom_missing_uscita ? missingStyle : undefined}>{formatOra(p.entrata_pom)}</td>
                <td>{formatOra(p.uscita_pom)}</td>
                <td>{minutiCalcolati > 0 ? minutiToHHMM(minutiCalcolati) : '-'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DashboardPresenze;
